<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <BackButton
              :label="$t('general.button.back')"
              :to="{ name: 'userForm', params: { id: userId } }"
              marginBottom="5"/>

          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Mitarbeiter -  {{userData?.firstName}} {{userData?.lastName}}
            </h6>
          </div>

          <div class="element-box">
            <form @submit.prevent="submitForm" novalidate>
              <div class="row">
                <div class="col-lg-6">
                  <BaseInput v-model="formData.password"
                             label="Neues Passwort"
                             :required=true
                             :validation="v$.password"
                             :messages="v$.password.$errors[0]?.$message">
                  </BaseInput>

                  <div class="form-buttons-w text-center">
                    <SaveButton
                        :label="$t('general.button.save')"
                        :loading="isSubmitting"/>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import userService from '@/api/User';
import securityService from '@/api/Security/index';
import BaseInput from '@/components/base/BaseInput.vue';
import BackButton from '@/components/button/BackButton.vue';
import Sidebar from '@/components/FormSidebar.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { passwordRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';
import { useRoute } from 'vue-router';

const { t }        = useI18n();
const userData     = ref(null);
const isSubmitting = ref(false);
const route        = useRoute();
const userId       = route.params.id;

const formData = ref({
  password: '',
});

const rules = computed(() => {
  return {
    password: passwordRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    await securityService.changePasswordForUser(formData.value, +userId);
    await router.push({ name: 'userForm', params: { id: userId } });
    isSubmitting.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getUser() {
  try {
    const { data } = await userService.getUser(+userId);
    const { user } = data.data;
    userData.value = user;

  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getUser();
});

</script>

<style scoped>
</style>